/**
 * Sorts list of strings.
 * @param list a list of strings
 * @returns a sorted list of strings
 */
export function sortListOfStrings(lst: string[], other = "Other") {
  const list = [...lst];

  // If this list contains "Other", we want to push "Other" to the end of the list
  const otherIndex = list.findIndex((item: string) => item === other);

  // Remove "Other" (we'll add it back to end of the list after sorting)
  if (otherIndex > 0) {
    list.splice(otherIndex, otherIndex);
  }

  // Sort the list
  list.sort((a: string, b: string) => (a < b ? -1 : 1));

  // Put "Other" back onto the end of the list
  if (otherIndex > 0) {
    list.push(other);
  }

  return list;
}

/**
 * Sorts a list of objects by a key in the object.
 * @param sortBy a key in the object
 * @param lst a list of objects
 * @returns a sorted list
 */
export function sortListByAttribute<T>(
  sortBy: keyof T,
  lst: T[],
  other = "Other"
) {
  const list = [...lst];

  let itemOther: T[] = [];

  // If this list contains "Other", we want to push "Other" to the end of the list
  const otherIndex = list.findIndex((item: T) => item[sortBy] === other);

  // Remove "Other" (we'll add it back to end of the list after sorting)
  if (otherIndex > 0) {
    itemOther = list.splice(otherIndex, otherIndex);
  }

  // Sort the list
  list.sort((a: any, b: any) => (a[sortBy] < b[sortBy] ? -1 : 1));

  // Put "Other" item back onto the end of the list
  if (otherIndex > 0) {
    list.push(itemOther[0]);
  }

  return list;
}
